<template>
  <section class="section">
    <slot />
  </section>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
.section {
  margin: 0 auto;
}
</style>